// ** React Imports
import { useCallback, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useOpenGraphMetaTags from "hooks/useOpenGraphMetaTags";
import useFilterPeriod from "hooks/filters/useFilterPeriod";

// ** Config
import configGlobal from "configuration";

// #####################################################

const useRankingsMetaTags = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors", "pages"]);

	// ** Hook - useLocation
	const location = useLocation();

	// ** Język
	const language = useSelector((state) => state.globalCommon.language);

	// ** Odczytanie parametrów z adresu URL
	const {
		rankingPeriod: filterPeriodParam = "today",
		sex: filterSexParam = "", //"woman-man-couple-transsexual",
	} = useParams();

	// ** Hook useFilter - Zakres dat
	const { items } = useFilterPeriod({
		initial: {},
	});

	// ** Hook useMemo - Przygotowanie Części Tytułu Zawierającego Wybrane Płcie
	const selectedSexTranslatedSex = useMemo(
		() =>
			filterSexParam
				.split("-")
				.map((item) => t(`common:sexOptions.${item}`))
				.join(", "),
		[filterSexParam, language]
	);

	// ** Hook useMemo - Wybrany okres rankingu w zależnoości od 'filterPeriodParam'
	const selectedPeriod = useMemo(
		() => items.find((item) => item.meta.url === filterPeriodParam),
		[filterPeriodParam]
	);

	// ** SEO TITLE
	const title = t(`pages:rankings`);

	// ** SEO DESCRIPTION
	const metaDescription = useMemo(() => {
		return `Umawiaj się na sex spotkania albo znajdź partnera na dłużej! Zobacz najpopularniejszych użytkowników z ${selectedPeriod?.text}. Płeć: ${selectedSexTranslatedSex}.`;
	}, [filterPeriodParam, selectedSexTranslatedSex]);

	// ** Open Graph Meta Tags
	const ogMetaTags = useOpenGraphMetaTags({
		customTitle: `${title} - ${t("common:titleTemplate")}`,
		customDescription: metaDescription,
		customUrl: `https://${configGlobal.host}${
			location.pathname.includes("undefined")
				? location.pathname.replace("/undefined", "")
				: location.pathname
		}`,
	});

	const canonicalLink = useCallback(() => {
		return (
			<link
				rel="canonical"
				href={`https://${configGlobal.host}/rankings`}
			/>
		);
	}, []);

	return { title, metaDescription, ogMetaTags, canonicalLink };
};

// #####################################################

export default useRankingsMetaTags;

// #####################################################
